module.exports = __webpack_public_path__ + "static/img/icon_art.b5fcb6cd.png";